// Ordinal formatting: 1 -> "1st", 2 -> "2nd", 11 -> "11th", 112 -> "112th".
// Shared util, never duplicate per component.
export function ordinal(n) {
  if (n === null || n === undefined || n === "") return "";
  const num = Number(n);
  if (Number.isNaN(num)) return "";
  const mod100 = num % 100;
  if (mod100 >= 10 && mod100 <= 20) return `${num}th`;
  const suffix = { 1: "st", 2: "nd", 3: "rd" }[num % 10] || "th";
  return `${num}${suffix}`;
}
